<template lang="pug">
.subscriptionBadgeComponent(:class="cssClass")
  .counter {{ counter !== 0 ? counter : '!' }}
</template>

<script>
export default {
  props: {
    counter: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cssClass () {
      return {
        _orange: this.counter <= 1,
        _yellow: this.counter > 1 && this.counter <= 3,
        _blue: this.counter > 3
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.subscriptionBadgeComponent
  width: 11*$u
  height: 11*$u
  border-radius: 99em
  border: $u solid
  display: flex
  align-items: center
  justify-content: center

  > .counter
    @include font('h3')

  &._orange
    color: $cOrange
    border-color: $cOrange

  &._yellow
    color: $cYellow
    border-color: $cYellow

  &._blue
    color: $cBlue
    border-color: $cBlue
</style>
